import React from "react";
import HeroPageCulture from "./HeroPage";
import ValueSection from "./ValueSection";
import LifeAtNPCards from "./LifeAtNPCards";
import ImgSection from "./ImgSection";
import FoundersSection from "./FoundersSection";

function Culture() {
  return (
    <>
    
      <HeroPageCulture />
      <ValueSection />
      <LifeAtNPCards />
      <ImgSection />
      <FoundersSection />
    </>
  );
}

export default Culture;
